import { useState } from 'react';

const useLocalStorage = (key: string, initialValue: any) => {
  let local;
  try {
    local = JSON.parse(localStorage.getItem(key) as string);
  } catch (err) {
    console.error('There is no localStorage API');
  }

  if (!local) {
    localStorage.setItem(key, JSON.stringify(initialValue));
    local = initialValue;
  }

  const [state, _setState] = useState(local);
  const setState = (updater: any) => {
    _setState((old: any) => {
      let res;
      if (typeof updater === 'undefined') {
        res = (updater as any)(old);
      } else {
        res = updater;
      }
      localStorage.setItem(key, JSON.stringify(res));
      return res;
    });
  };
  return [state, setState];
};

export default useLocalStorage;
